<i18n src="./resources/locales.json"></i18n>

<template>
  <v-app-bar outlined class="app-bar-border" app color="#121212" grow>
    <div class="app-bar-img-container">
      <img src="@/assets/xtiumcolor_x_mark.svg" class="app-bar-img" alt="evolve-ip" @click="onLogoClick" />
      <v-divider class="mx-4" vertical></v-divider>
    </div>
    <div class="mb-n2">
      <v-tabs :value="tabValue" background-color="#121212">
        <v-tab v-for="tab in tabs" :key="tab.to" :href="`#${tab.to}`" @click="() => navigateTo(tab.to)">
          {{ tab.text }}
        </v-tab>
      </v-tabs>
    </div>
    <div class="d-flex display-row">
      <div class="pr-4 text-right">
        <div id="ecs-app-bar-name">{{ name }}</div>
        <div id="ecs-app-bar-role" class="user-role">{{ role }}</div>
      </div>
      <EcsAvatar :agent-id="userInfo && userInfo.id" :alt="name || ''" />
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAvatar from '@/components/ecs-avatar/EcsAvatar';

export default {
  name: 'EcsAppBar',
  components: { EcsAvatar },
  data() {
    return {
      tabs: [
        {
          text: 'Summary',
          to: '/summary'
        },
        {
          text: 'Branding',
          to: '/branding'
        },
        {
          text: 'Templates',
          to: '/templates'
        },
        {
          text: 'Behaviours',
          to: '/behaviours'
        },
        {
          text: 'Resources',
          to: '/resources'
        },
        {
          text: 'Contact Management',
          to: '/contact-management'
        }
        // {
        //   text: 'SMS',
        //   to: '/sms-provisioning'
        // }
      ],
      tabValue: '/summary'
    };
  },

  mounted() {
    this.tabValue = this.$route.path.toLowerCase();
  },

  computed: {
    ...mapGetters(['username', 'userRole', 'userInfo']),
    role() {
      return this.userRole;
    },
    name() {
      return this.userInfo ? this.userInfo.name : this.username;
    }
  },

  methods: {
    navigateTo(to) {
      this.$router.push(to);
    },
    onLogoClick() {
      const to = '/summary';
      this.tabValue = to;
      this.navigateTo(to);
    }
  }
};
</script>

<style>
.app-bar-border .v-toolbar__content {
  justify-content: space-between;
}

.app-bar-img-container {
  height: 40px;
}

.app-bar-img {
  cursor: pointer;
  width: 40px;
}

.v-avatar.app-bar-avatar {
  border-radius: 50%;
}

.app-bar-border {
  border-bottom: 1px solid white;
}

.user-role {
  font-size: 11px;
  opacity: 0.5;
  margin-top: -2px;
}
</style>
